import { pushToAdobeDataLayer } from "utils-lib/analytics/adobeDataLayer"

const SEARCH_SUBMIT = "global-search-query-submit-input"

export const pushSearchSubmitData = (searchTerm) => {
  const acdlData = {
    clicks: {
      object_content: {
        searchTerm,
        siteSearch: "Global",
        eventName: SEARCH_SUBMIT,
      },
    },
  }
  pushToAdobeDataLayer(SEARCH_SUBMIT, acdlData)
}
